import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button, Alert } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import IdentityInput from 'components/form-elements/IdentityInput';

const AddForm = ({ visible, error, submitting, handleCloseForm, handleSubmitForm }) => {
  const [form] = Form.useForm();
  const [fields, setFields] = useState([{ key: 0, number: '', type: 'VKN' }]);

  const checkNumber = (rule, value) => {
    if (Number.isInteger(Number(value.number))) {
      if (value.type === 'VKN') {
        if (value.number.trim().length === 10) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('Vergi Numarası 10 haneli olmalıdır.'));
      }
      if (value.type === 'TCKN') {
        if (value.number.trim().length === 11) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('TC Numarası 11 haneli olmalıdır.'));
      }
      return Promise.reject(new Error('Zorunlu Alan'));
    }
    return Promise.reject(new Error('Sadece rakamlardan oluşmalıdır.'));
  };

  const addField = () => {
    setFields([...fields, { key: fields.length, number: '', type: 'VKN' }]);
  };

  const removeField = (key) => {
    if (fields.length === 1) return;
    setFields(fields.filter((field) => field.key !== key));
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleSubmitForm(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  return (
    <Modal
      open={visible}
      footer={false}
      title="Üye İşyeri Ekleme"
      onCancel={handleCloseForm}
      destroyOnClose
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        {fields.map((field, index) => (
          <Form.Item key={field.key}>
            <Form.Item
              name={['identityNumberList', index]}
              initialValue={field}
              validateTrigger={['onChange', 'onBlur']}
              rules={[{ validator: checkNumber }]}
              noStyle
            >
              <IdentityInput />
            </Form.Item>
            {fields.length > 1 && (
              <MinusCircleOutlined
                className="dynamic-delete-button indentity-remove"
                onClick={() => removeField(field.key)}
              />
            )}
          </Form.Item>
        ))}
        <Form.Item>
          <Button type="dashed" onClick={addField} style={{ width: '100%' }}>
            <PlusOutlined /> Numara Ekle
          </Button>
        </Form.Item>
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Form.Item className="text-align-right">
          <Button
            className="button button__outline mr-3"
            type="ghost"
            htmlType="button"
            disabled={submitting}
            onClick={handleCloseForm}
          >
            Vazgeç
          </Button>
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
};

AddForm.defaultProps = {
  error: null,
};

export default AddForm;
